import { store } from "@/lib/store";

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
let loaded = false;

export const gaEnabled = () => Boolean(GA_ID) && store.getConsent() === "granted";

export function loadGA() {
  if (loaded || !gaEnabled()) return;
  loaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { anonymize_ip: true, send_page_view: false });
}

export function gaPageview(path) {
  if (!gaEnabled()) return;
  loadGA();
  window.gtag("event", "page_view", { page_path: path, page_location: window.location.href, page_title: document.title });
}

export function disableGA() {
  if (GA_ID) window[`ga-disable-${GA_ID}`] = true;
}
